import { ButtonDropdown, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReceiptsSortingWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${Spacing.S24};
  flex-gap: ${Spacing.S16};
`

export const ButtonDropdownWrapper = styled(ButtonDropdown)`
  width: 260px;
  margin-left: ${Spacing.S16};
` as typeof ButtonDropdown
